import type { CSSObject } from '@emotion/react'
import { NARROW_SCREEN_HANDLE_SIZE } from 'components/DetailPanel/detailPanelHandleSize'
import { PHONE_MAP_CARD_Z_INDEX } from './phoneMapCardZIndex'

export const cardCSSAboveDetailsPanel: CSSObject = {
  'zIndex': PHONE_MAP_CARD_Z_INDEX,
  // The bar sits on the bottom inset, which the card's footer margin already adds, so the bar's height is enough
  '@media (orientation: portrait)': { bottom: NARROW_SCREEN_HANDLE_SIZE },
}
